import { render, staticRenderFns } from "./TagStep.vue?vue&type=template&id=44f60798&scoped=true&"
import script from "./TagStep.vue?vue&type=script&lang=js&"
export * from "./TagStep.vue?vue&type=script&lang=js&"
import style0 from "./TagStep.vue?vue&type=style&index=0&id=44f60798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f60798",
  null
  
)

export default component.exports